
import { Vue, Component, Prop } from "vue-property-decorator";
import GET_VISITS_COUNTS from "@/apollo/projects/GetContractorClientVisitsTypeAggregate.gql";
import { User, Company } from "@/generated/graphql";
import RadioButtonGroup from "@/components/common/RadioButtonGroupNew.vue";
import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholder.vue";
import EmptyListImageProjects from "@/components/icons/emptyListImages/EmptyListImageProjects.vue";
import { cloneDeep } from "lodash-es";
import PaginationConfig from "@/entities/PaginationConfig";
import paginationConfig from "@/data/paginationConfig";
import { isEqual } from "lodash-es";
import OfferedVisits from "./OfferedVisits.vue";
import AcceptedVisits from "./AcceptedVisits.vue";
import contractorClientsVisitsFiltersTemplate from "@/data/filtersTemplates/contractorClientsVisitsFiltersTemplate";
import {
  getEmptyFiltersResultMessage,
  getEmptyListMessage,
} from "@/helpers/lists/emptyListMessagesNew";
import moment from "moment";

const visitStatus = {
  OFFERED: "OFFERED",
  ACCEPTED: "ACCEPTED",
};

@Component({
  components: {
    RadioButtonGroup,
    EmptyListPlaceholder,
    EmptyListImageProjects,
    OfferedVisits,
    AcceptedVisits,
  },
  apollo: {
    totalVisitsCounts: {
      query: GET_VISITS_COUNTS,
      variables() {
        return this.visitsCountsQueryFilter;
      },
      update(data) {
        this.totalOfferedVisitsCounts =
          data?.total_offered_visits_aggregate?.aggregate?.count;
        this.totalAcceptedVisitsCounts =
          data?.total_accepted_visits_aggregate?.aggregate?.count;
        return data;
      },
      skip() {
        return !this.currentUser?.id;
      },
    },
  },
})
export default class ClientProjectsVisits extends Vue {
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Object, required: true }) readonly company!: Company;

  currentVisitTab = visitStatus.OFFERED;
  visitStatus = visitStatus;
  totalVisitsCounts = null;
  projectFilters = cloneDeep(contractorClientsVisitsFiltersTemplate);
  paginationConfig: PaginationConfig = { ...paginationConfig };
  totalOfferedVisitsCounts: number = 0;
  totalAcceptedVisitsCounts: number = 0;

  get radioOptions() {
    return [
      {
        value: visitStatus.OFFERED,
        label: "Offered",
        total: this.totalOfferedVisitsCounts || 0,
      },
      {
        value: visitStatus.ACCEPTED,
        label: "Accepted",
        total: this.totalAcceptedVisitsCounts || 0,
      },
    ];
  }

  get loading(): boolean {
    return this.$apollo.loading;
  }
  get visitsCountsQueryFilter() {
    return {
      currentUserId: this.currentUser.id,
      currentDate: moment().format("YYYY-MM-DD"), // Pass the current date in YYYY-MM-DD format
    };
  }
  get emptyListMessage(): string {
    const entitiesName = "clients";
    const filtersEmpty = isEqual(
      this.projectFilters,
      contractorClientsVisitsFiltersTemplate
    );

    if (filtersEmpty) {
      return getEmptyListMessage(entitiesName);
    }

    return getEmptyFiltersResultMessage(entitiesName);
  }
}
